export default __webpack_public_path__ + "static/nodejs-cf54ab47c3feeba8d5a983145de0c77e.png";